import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import Modal from '../../../commonComponents/modal/Modal';
import ModalHeader from '../../../commonComponents/modal/ModalHeader';
import ModalFooter from '../../../commonComponents/modal/ModalFooter';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';

function FinishedSessionModal({ t, onClose, name }) {
  const handleCancel = () => onClose(false);
  return (
    <Modal onClose={handleCancel}>
      <div className="modal-dialog">
        <div className="modal-content">
          <ModalHeader title={name} onClose={handleCancel} />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="portlet-body form">
                  <p style={{ paddingLeft: '20px' }}>{`${t('sessionDetails_modal.finishedSession')}!`}</p>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={handleCancel}
            saveText={t('confirm')}
          />
        </div>
      </div>
    </Modal>
  );
}

FinishedSessionModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default compose(
  translate,
  withCSRF,
)(FinishedSessionModal);
